export default function percentage(v, total) {
  if (total === 0) {
    return 'n/a'
  }
  return `${Math.round((total ? v / total : v) * 100)}%`
}
